// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__XOhfT","buttons":"SendReceipts_buttons__ML5zD","email":"SendReceipts_email__1qr26","bookApptTitle":"SendReceipts_bookApptTitle__3lKz5"};